import UrlParams from 'embed/UrlParams';

const DEFAULT_EMBED_URL = 'https://diskuze.seznam.cz/v3';
const DEFAULT_API_URL = 'https://fapi.seznamdiskuze.cz/graphql';
const DEFAULT_WIDGET_URL = 'https://widget.diskuze.seznam.cz';
const LOCAL_STORAGE_KEY = '_szn_discussion_';

function provideDefaultValue(value, defaultValue) {
	return typeof value === 'undefined' ? defaultValue : value;
}

function getLocalStorageData() {
	try {
		if (!window.localStorage) {
			return {};
		}
	} catch (error) {
		//Local Storage is not accessible!
		return {};
	}

	const data = window.localStorage.getItem(LOCAL_STORAGE_KEY);
	const parsedData = JSON.parse(data) || {};

	if (parsedData.expire) {
		const now = new Date();

		if (now.getTime() > parsedData.expire) {
			window.localStorage.removeItem(LOCAL_STORAGE_KEY);

			return {};
		}

		return parsedData.value;
	}

	return parsedData;
}

export default function createEmbedConfig(values, isStagingBuild) {
	if (values.embedUrl) {
		values.embedUrl = values.embedUrl.replace(/\/*$/g, '');
	}

	const config = {
		isStagingBuild: provideDefaultValue(isStagingBuild, false),
		embedUrl: provideDefaultValue(values.embedUrl, DEFAULT_EMBED_URL),
		apiUrl: provideDefaultValue(values.apiUrl, DEFAULT_API_URL),
		widgetUrl: provideDefaultValue(values.widgetUrl, DEFAULT_WIDGET_URL),
		linksInNewTab: provideDefaultValue(values.linksInNewTab, false),
		allowScroll: provideDefaultValue(values.allowScroll, true),
		userIdentityScriptUrl: provideDefaultValue(
			values.userIdentityScriptUrl,
			'https://d818-a.sdn.cz/d_818/sl/1/stable/user-identity.js'
		)
	};

	const masterOverride = getLocalStorageData();

	Object.assign(config, masterOverride);
	Object.freeze(config);

	return config;
}

export function createCommentCountConfig(values = {}) {
	const localStorageData = getLocalStorageData();

	const config = {
		apiUrl: provideDefaultValue(values.apiUrl, DEFAULT_API_URL)
	};

	if (localStorageData.commentCountApiUrl) {
		config.apiUrl = localStorageData.commentCountApiUrl;
	}

	Object.freeze(config);

	return config;
}

export function getTopicSettings() {
	const searchParams = new URLSearchParams(window.location.search);
	const paramsToAdd = {};

	if (searchParams.has(UrlParams.TOPIC_ID_SEARCH_PARAM)) {
		paramsToAdd.topicId = searchParams.get(UrlParams.TOPIC_ID_SEARCH_PARAM);
	}

	if (searchParams.has(UrlParams.SHOW_COMMENT_ID_SEARCH_PARAM)) {
		paramsToAdd.firstCommentId = searchParams.get(
			UrlParams.SHOW_COMMENT_ID_SEARCH_PARAM
		);
	}

	return paramsToAdd;
}
